export default __webpack_public_path__ + "static/media/Mission.a2a33a66.jpeg";